import React, { useState } from 'react'
import styled from 'styled-components'
import { selectCustomStyles } from '@appearance/styled'
import Select from 'react-select'
import Pagination from 'react-js-pagination'
import { Text } from 'grommet'
import { useWindowSize } from '@services/layout'
import i18n from '@localization/i18n'

const PAGE_SIZE_OPTIONS = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
]

export default ({
    totalItems,
    page,
    pageSize,
    onChangePage,
    onChangePageSize,
    hidePageSize,
}) => {
    if (!totalItems) {
        return null
    }
    const [windowSize, setWindowSize] = useState(useWindowSize())
    const totalRecords = totalItems
    const diplayingFrom = (Number(page) - 1) * Number(pageSize) + 1
    let diplayingTo = diplayingFrom + Number(pageSize) - 1
    const getLayoutStyle = () => {
        if (windowSize.width < windowSize.height) {
            return true
        }
        return false
    }

    if (diplayingTo > totalRecords) {
        diplayingTo = totalRecords
    }

    const currentRecordsDisplayMsg =
        i18n.t('table.presenting_results') +
        ' ' +
        (i18n.locale === 'he' ? diplayingTo : diplayingFrom) +
        '-' +
        (i18n.locale === 'he' ? diplayingFrom : diplayingTo) +
        ' ' +
        i18n.t('table.out_of') +
        ' ' +
        totalRecords
    const isMobileLayout = getLayoutStyle()

    return (
        <Container isMobileLayout={isMobileLayout}>
            <Pagination
                activePage={Number(page)}
                itemsCountPerPage={Number(pageSize)}
                totalItemsCount={totalItems}
                pageRangeDisplayed={5}
                onChange={onChangePage}
                itemClass="page-item"
                linkClass="page-link"
                activeLinkClass="custom-color"
            />
            <SizeAndResultContainer isMobileLayout={isMobileLayout}>
                <ResultsCountText isMobileLayout={isMobileLayout}>
                    {currentRecordsDisplayMsg}
                </ResultsCountText>
                {!hidePageSize && (
                    <SizeSelect
                        isMobileLayout={isMobileLayout}
                        styles={selectCustomStyles}
                        value={PAGE_SIZE_OPTIONS.find(
                            (opt) => opt.value === pageSize
                        )}
                        onChange={(obj) => onChangePageSize(obj.value)}
                        options={PAGE_SIZE_OPTIONS}
                        isSearchable={false}
                    />
                )}
            </SizeAndResultContainer>
        </Container>
    )
}

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-direction: ${(p) => (p.isMobileLayout ? 'column' : 'row')};
    padding-bottom: 20px;
    padding-left: ${(p) => (p.isMobileLayout ? 0 : 20)}px;
    padding-right: ${(p) => (p.isMobileLayout ? 0 : 20)}px;
`
const SizeAndResultContainer = styled.div`
    width: 85%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: ${(p) => (p.isMobileLayout ? 0 : 0)} px
        ${(p) => (p.isMobileLayout ? 0 : 0)}px;
    padding-top: ${(p) => (p.isMobileLayout ? 10 : 0)}px;
    padding-bottom: ${(p) => (p.isMobileLayout ? 15 : 0)}px;
`

const SizeSelect = styled(Select)`
    max-width: 80px;
    flex: 1;
    justify-content: ${(p) => (!p.isMobileLayout ? 'flex-start' : 'flex-end')};
    flex: ${(p) => (p.isMobileLayout ? 7 : 1)};
`
const ResultsCountText = styled(Text)`
    color: grey;
    font-size: 12px;
    display: flex;
    margin-right: 4px;
    padding-top: 7.5px;
    white-space: nowrap;
    flex: ${(p) => (p.isMobileLayout ? 1 : 7)};
    margin-left: 5px;
`
